import isType from "./isType";

const isDate = value => isType(value, "Date");

export default isDate;
//# sourceMappingURL=isDate.js.map